import { render, staticRenderFns } from "./FormulateBinSlider.vue?vue&type=template&id=3896757b&"
import script from "./FormulateBinSlider.js?vue&type=script&lang=js&"
export * from "./FormulateBinSlider.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3896757b')) {
      api.createRecord('3896757b', component.options)
    } else {
      api.reload('3896757b', component.options)
    }
    module.hot.accept("./FormulateBinSlider.vue?vue&type=template&id=3896757b&", function () {
      api.rerender('3896757b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Formulate/FormulateBinSlider/FormulateBinSlider.vue"
export default component.exports